import React from 'react';

import { StyledSingleActionButton } from '../connect-provider.styled';
import { ConnectProviderStatus } from '../enums';
import { MultipleActions } from '../MultipleActions';
import { ProviderAnalyticLiteralIds } from '../types';

export interface ConnectCsvProviderActionsProps {
  analyticIds: ProviderAnalyticLiteralIds;
  close: () => void;
  restart: () => void;
  connectProvider: () => void;
  providerName: string;
  retry: () => void;
  status: ConnectProviderStatus;
  isSubmitButtonDisabled?: boolean;
}

export const ConnectCsvProviderActions = ({
  analyticIds,
  close,
  connectProvider,
  isSubmitButtonDisabled,
  providerName,
  restart,
  retry,
  status,
}: ConnectCsvProviderActionsProps): React.ReactElement | null => {
  switch (status) {
    case ConnectProviderStatus.SUCCESS: {
      return (
        <StyledSingleActionButton
          variant="primary"
          rounded="regular"
          size="base"
          onClick={close}
          id={analyticIds.closeAfterSuccessButtonId}
        >
          Close
        </StyledSingleActionButton>
      );
    }
    case ConnectProviderStatus.ERROR: {
      return (
        <MultipleActions
          actions={[
            {
              button: {
                variant: 'primary',
                rounded: 'regular',
                size: 'base',
                onClick: retry,
                children: 'Previous Step',
                id: analyticIds.previousStepId,
              },
            },
            {
              button: {
                variant: 'white',
                rounded: 'regular',
                size: 'base',
                onClick: close,
                children: `Cancel ${providerName} Connection`,
                id: analyticIds.cancelConnectionId,
              },
            },
          ]}
        />
      );
    }
    case ConnectProviderStatus.NOT_STARTED:
    case ConnectProviderStatus.WAITING_TOKEN:
    case ConnectProviderStatus.FILE_ADDED:
      return (
        <MultipleActions
          actions={[
            {
              button: {
                variant: 'white',
                rounded: 'regular',
                size: 'base',
                onClick: restart,
                children: 'Cancel and Go Back',
                id: analyticIds.cancelConnectionId,
              },
            },
            {
              button: {
                variant: 'primary',
                rounded: 'regular',
                size: 'base',
                disabled: status !== ConnectProviderStatus.FILE_ADDED || isSubmitButtonDisabled,
                onClick: connectProvider,
                children: 'Upload',
                id: analyticIds.connectId,
              },
            },
          ]}
        />
      );
    default:
      return null;
  }
};
